import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface RelatedCompaniesTooltipProps {
  openLeft: boolean
}

const RelatedCompaniesTooltip: React.FC<RelatedCompaniesTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {translate(
          "${relatedCompanies} are any companies associated with the customer. This includes any companies associated with accounts they own, as well as any companies from which they've received budgets or virtual cards. This is not the same as organization membership.",
          {
            relatedCompanies: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Related companies')}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default RelatedCompaniesTooltip
